import { ReactNode, useState } from "react";
import styles from "../../styles/navbar.module.css";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useClientSession } from "../../provider/ClientSessionProvider";
import Image from "../common/Image";
import Credence_Logo from "/assets/credenceidlogo.png";
import Timer from "./Timer";
import Modal from "../modal/Modal";
import { modalType } from "../../types/modal";
import { useTranslation } from "react-i18next";

interface Props {
  children: ReactNode;
}

const NavBar: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { endSession } = useClientSession();
  const [exitOpen, setExitOpen] = useState(false);

  function handleOnExpire() {
    endSession();
  }

  const isSmallScreen = useMediaQuery("(max-width:960px)");
  const inCaptureFlow = location.pathname.startsWith("/onboard");

  return (
    <>
      {location.pathname == "/" && isSmallScreen ? (
        <div className={styles.welcomeNavContainer}>
          <Image src={Credence_Logo} className={styles.logo} />
        </div>
      ) : (
        <div className={styles.navbarContainer}>
          {children}

          {inCaptureFlow && (
            <div className={styles.captureControls}>
              <div className={styles.timerContainer}>
                {!isSmallScreen && t("timeremaining")}{" "}
                <Timer onExpire={handleOnExpire} />
              </div>

              {/*
                The way out, on every capture step.

                Exiting was only offered on the review screen at the end, so an
                applicant who wanted to stop part-way through had nothing to press:
                the browser back button walks one step at a time and the flow has
                no other escape. Sitting in the navbar keeps it reachable from
                wherever they are without competing with the step's own actions.
              */}
              <button
                type="button"
                className={styles.exitButton}
                onClick={() => setExitOpen(true)}
              >
                {t("button.exit")}
              </button>
            </div>
          )}
        </div>
      )}

      {/*
        Confirmed rather than immediate: leaving discards every capture taken so
        far, and this button sits next to a running timer where a misclick is easy.
      */}
      <Modal
        type={modalType.ON_EXIT}
        isOpen={exitOpen}
        onClose={() => setExitOpen(false)}
        actions={{ continue: endSession }}
      />
    </>
  );
};

export default NavBar;
